/**
 * © 2025 Indikin.online. All rights reserved.
 * Made with ❤️ by YalaCoder.
 *
 * Updated User Context Definition
 *
 * - REWRITTEN FILE
 * - MISSION: To update the shape of the UserContext to align with the new
 * Firebase-powered UserProvider.
 *
 * - CHANGES:
 * 1.  The default context value now includes `user: null`, `loading: true`,
 * and a no-op `signOutUser` function.
 * 2.  This new shape accurately reflects the data that consuming components
 * will receive from the rewritten UserProvider, ensuring type consistency
 * and preventing errors.
 * 3.  The old `userEmail` and `setUserEmail` properties have been removed.
 */
import { createContext } from 'react';

// Create and export the context with the new shape.
export const UserContext = createContext({
  user: null,
  loading: true,
  signOutUser: () => {},
});
